import { useState, useEffect, useContext } from 'react';
import { Pagination, Skeleton, Table } from "@mantine/core";
import moment from "moment";
import { ETable } from "../table/ETable";
import { EEmpty } from "../Empty/EEmpty";

import { useDirectusApi } from "../../../data-access";
import { IPatientInformation } from "../../../data-access/types";
import Filter, { IAvailableFilters, TPayload } from "./component/Filter";
import { humanize } from '../../../../utils/utility';
import { AppContext } from '../../../../AppContext';

interface EPatientListProps {
    allowedFilters?: IAvailableFilters;
    onRowClick?: (patient: IPatientInformation) => void;
}





export function EPatientList({ allowedFilters, onRowClick, }: EPatientListProps) {
    const { fetchDirectData } = useDirectusApi();
    const [patientList, setPatientList] = useState<any[]>([]);
    const [totalPage, setTotalPage] = useState<number>(1);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [payload, setPayload] = useState<TPayload>();

    const { role, user } = useContext(AppContext);

    const limit = 20;

    const handleGetPatientList = async (cp?: number) => {
        setPatientList([]);
        setIsLoading(true);
        let [firstName, lastName] = payload?.search ? payload?.search?.split(" ") : [];

        let searchQuery = `custom/patient-list?limit=${limit}&offset=${payload?.search ? 1 : cp ? cp : currentPage}`
        // filter
        searchQuery += `` + `${role?.includes("Center") ? `&center_id=${user?.id}` : payload?.centerId ? `&center_id=${payload?.centerId}` : ``}`
            + `${firstName ? `&first_name=${firstName}` : ""}`
            + `${lastName ? `&last_name=${lastName}` : ""}`
            + `${payload?.include ? `&inclusion_status=${payload?.include}` : ``}`
            // + `&filter[disease_case][_eq]=["symptomatic_gallstone"]`
            + `${payload?.disease_case ? `&disease_case=${payload?.disease_case}` : ``}`

        try {
            let patientProfileData = await fetchDirectData(searchQuery);
            if (patientProfileData?.data) {

                setTotalPage(Math.ceil(patientProfileData?.data[0]?.full_count / limit));
                cp && setCurrentPage(cp);
                setPatientList(patientProfileData?.data);
            } else {
                setPatientList([]);
            }
        } catch (error) {
            console.error("Error fetching patient list:", error);
            setPatientList([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (role && user) {
            // if (role?.includes("Center")) {
            //     setPayload((prev) => ({ ...prev, centerId: user?.id }));
            // }
            handleGetPatientList();
        }
    }, [role, user]);

    useEffect(() => {
        if (!payload?.centerId && !payload?.include && !payload?.disease_case && !payload?.search) {
            handleGetPatientList();
        }
    }, [payload]);

    return (
        <div className="w-full">
            <Filter
                filter={payload}
                onChangeFilter={(e) => setPayload((prev) => ({ ...prev, [e.key]: e.value }))}
                allowedFilters={{
                    ...allowedFilters,
                    centerId: role?.includes("Center") ? false : allowedFilters?.centerId,
                }}
                onClearFilter={() => {
                    setPayload(undefined)
                }}
                onSubmitFilter={() => handleGetPatientList()}
            />

            {isLoading ? (
                <ETable>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>Name</Table.Th>
                            <Table.Th>Mobile Number</Table.Th>
                            <Table.Th>Alternate Mobile Number</Table.Th>
                            <Table.Th>Hospital Number</Table.Th>
                            <Table.Th>Recruitment Date</Table.Th>
                            <Table.Th>Address</Table.Th>
                            <Table.Th>Father Name</Table.Th>
                            <Table.Th>Mother Name</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {[1, 2, 3, 4, 5].map(row => (
                            <Table.Tr key={row}>
                                {[1, 2, 3, 4, 5, 6, 7, 8].map(col => (
                                    <Table.Td key={col}>
                                        <Skeleton height={40} />
                                    </Table.Td>
                                ))}
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </ETable>
            ) : patientList?.length ? (
                <ETable>
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>Name</Table.Th>
                            <Table.Th>Mobile Number</Table.Th>
                            <Table.Th>Alternate Mobile Number</Table.Th>
                            <Table.Th>Disease Case</Table.Th>
                            <Table.Th>Hospital Number</Table.Th>
                            <Table.Th>Recruitment Date</Table.Th>
                            <Table.Th>Address</Table.Th>
                            <Table.Th>Father Name</Table.Th>
                            <Table.Th>Mother Name</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {patientList?.map((e) => (
                            <Table.Tr
                                key={e.user_id}
                                className={onRowClick ? "cursor-pointer" : ""}
                                onClick={() => {
                                    console.log(e, "e");
                                    onRowClick?.(e)
                                }}
                            >
                                <Table.Td>
                                    <div className="whitespace-nowrap">
                                        {e?.first_name + " " + e?.last_name + ` (${e?.age}, ${e?.gender?.charAt(0).toUpperCase()})`}
                                    </div>
                                </Table.Td>
                                <Table.Td>{e?.primary_contact_no}</Table.Td>
                                <Table.Td>{e?.alternate_contact_no}</Table.Td>
                                <Table.Td>{humanize(e?.disease_case?.join(", "))}</Table.Td>
                                <Table.Td>{e?.hospital_no}</Table.Td>
                                <Table.Td>{e?.recruitment_date ? moment(e?.recruitment_date).format("DD MMM YYYY") : "-"}</Table.Td>
                                <Table.Td>{e?.address}</Table.Td>
                                <Table.Td>{e?.father_name}</Table.Td>
                                <Table.Td>{e?.mother_name}</Table.Td>
                            </Table.Tr>
                        ))}
                    </Table.Tbody>
                </ETable>
            ) : (
                <EEmpty title="Not found any patient" description="Please add a new Patient" />
            )}

            <div className="flex justify-between mt-4">
                <div></div>
                <Pagination
                    size="sm"
                    value={currentPage}
                    onChange={(e) => handleGetPatientList(e)}
                    total={totalPage}
                />
            </div>
        </div>
    );
}
